<template>
    <div class="">
        <!-- <img src="https://online.jsil.com/javax.faces.resource/JsilLogoo.jpg.xhtml?ln=images" alt="" srcset=""> -->
        <div class="fixed-header">
            <js-logo> </js-logo>
            <!-- <img
                src="logo-js.png"
                alt=""
                srcset=""
                style="max-width: 150px; position: relative; left: 10%"
            /> -->
            <div class="header-content">
                <h3>JS sahulat sarmayakari account signup</h3>
                <h5>Your bright future, just a few steps away!</h5>
                <h6>Keep your cnic and account details handy</h6>
            </div>
            <div class="header-bar">
                <!-- <base-header
                    :menu-listing="menuListing"
                    step-style
                    base-logo
                ></base-header> -->
                <div
                    :class="
                        (stepStyle == true ? 'step-menu-header' : '',
                        mainMain == true ? 'show-menu' : '')
                    "
                >
                    <div
                        class="header-menu navigation"
                        :class="stepStyle == true ? 'step-menu' : ''"
                    >
                        <span class="close-side-bar" @click="mainMain = false"
                            ><i class="icon-delete"></i
                        ></span>
                        <div
                            v-if="$route.meta.showSideBar == false"
                            class="logo-container"
                        >
                            
                        </div>
                        <ul class="menu-list">
                            <li
                                v-for="(list, index) in allowedMenuListing"
                                :key="index"
                                :class="[
                                    $route.meta.sessionStep &&
                                    $route.meta.sessionStep == list.sessionStep
                                        ? 'router-link-exact-active'
                                        : '',
                                    $route.meta.sessionStep &&
                                    $route.meta.sessionStep >= list.sessionStep
                                        ? 'router-link-active'
                                        : '',
                                ]"
                                @click="mainMain = false"
                            >
                                <router-link
                                    :to="setRouterName(list)"
                                    :class="[
                                        $route.name.toString() ===
                                        list.name.toString()
                                            ? 'router-link-active router-link-exact-active'
                                            : '',
                                        $route.meta.innerTabName ==
                                        list.menuLabel.toString()
                                            ? 'router-link-active router-link-exact-active'
                                            : '',
                                    ]"
                                >
                                    <span v-if="stepStyle" class="point">
                                        <i class="icon-check-circle"></i>
                                    </span>
                                    <span>{{ list.menuLabel }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div
                        v-if="$route.meta.showSideBar == true"
                        class="profile-block"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loginDetail from '@/components/LoginDetail.vue'
import updateProfilePopup from '@/components/popups/UpdateProfilePopup.vue'
import changePasswordPopup from '@/components/popups/ChangePasswordPopup.vue'
import { directive as onClickOutside } from 'vue-on-click-outside'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import JsLogo from './JsLogo.vue'

export default {
    components: {
        loginDetail,
        changePasswordPopup,
        updateProfilePopup,
        JsLogo
    },
    directives: {
        onClickOutside: onClickOutside,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        menuListing: {
            type: Array,
            default: null,
        },
        stepStyle: {
            type: Boolean,
            default: false,
        },
        params: {
            type: Object,
            default: undefined,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            mainMain: false,
            image: 'profile-pic.png',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['user', 'scopes']),

        allowedMenuListing() {
            if (this.menuListing) {
                return this.menuListing.filter((item) => {
                    return this.checkPermission(item.permission)
                })
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        checkPermission(scopes) {
            if (this.$route.meta.requiresAuth) {
                return !!_.intersection(scopes, this.scopes).length
            }
            return true
        },
        setRouterName(list) {
            // console.log('Ring')

            if (this.$route.meta.publicRegistration === true) {
                return { name: 'public-registration-' + list.name }
                // return "public-registration-"+list.name
            } else {
                return { name: list.name }
            }
            // return { name: list.name }
        },
    }, // End of Component > mounted
} // End of export default
</script>


<style>
</style>